import apiService from './apiService';

const BASE = '/api/admin/inventory-item-types';
const SERVICE_BASE = '/api/admin/inventory-item-services';

/**
 * 取得背包物品類型列表
 * @param {Object} params - { active_only?: 0|1 }
 */
export const getInventoryItemTypes = async (params = {}) => {
    return apiService.GET(BASE, params);
};

export const getInventoryItemType = async (id) => {
    return apiService.GET(`${BASE}/${id}`);
};

export const getInventoryItemTypeHolders = async (id) => {
    return apiService.GET(`${BASE}/${id}/holders`);
};

export const getInventoryTypeDefinitions = async (params = {}) => {
    return apiService.GET(`${BASE}/definitions`, params);
};

export const createInventoryItemType = async (data) => {
    return apiService.POST(BASE, data);
};

export const updateInventoryItemType = async (id, data) => {
    return apiService.PUT(`${BASE}/${id}`, data);
};

export const toggleInventoryItemType = async (id, isActive) => {
    return apiService.PATCH(`${BASE}/${id}/toggle`, { is_active: isActive });
};

export const deleteInventoryItemType = async (id) => {
    return apiService.DELETE(`${BASE}/${id}`);
};

/** 對應服務白名單 */
export const getInventoryItemServices = async (params = {}) => {
    return apiService.GET(SERVICE_BASE, params);
};

export const createInventoryItemService = async (data) => {
    return apiService.POST(SERVICE_BASE, data);
};

export const updateInventoryItemService = async (id, data) => {
    return apiService.PUT(`${SERVICE_BASE}/${id}`, data);
};

export const toggleInventoryItemService = async (id, isActive) => {
    return apiService.PATCH(`${SERVICE_BASE}/${id}/toggle`, {
        is_active: isActive
    });
};
